(function () {
  document.querySelectorAll('.banner-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.bc-track');
    var slides = carousel.querySelectorAll('.bc-slide');
    var dots = carousel.querySelectorAll('.bc-dot');
    var total = slides.length;
    if (total < 2) return;

    var current = 0;
    var autoplayMs = parseInt(carousel.dataset.autoplay || '4000', 10);
    var timer = null;
    var startX = 0;
    var isDragging = false;
    var dragDelta = 0;
    var dragStartScroll = 0;
    var didDesktopDrag = false;
    var isDesktop = function () { return window.innerWidth >= 768; };

    function getSlideWidth() {
      var slide = carousel.querySelector('.bc-slide');
      if (!slide) return carousel.offsetWidth * 0.88;
      return slide.offsetWidth + 10;
    }

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = 'translateX(-' + current * getSlideWidth() + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('bc-dot--active', i === current);
      });
    }

    function startAuto() {
      if (autoplayMs <= 0 || isDesktop()) return;
      timer = setInterval(function () { goTo(current + 1); }, autoplayMs);
    }

    function stopAuto() {
      clearInterval(timer);
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        resetAuto();
      });
    });

    function onStart(x) {
      isDragging = true;
      startX = x;
      dragDelta = 0;
      stopAuto();
      if (isDesktop()) {
        dragStartScroll = carousel.scrollLeft;
        didDesktopDrag = false;
        carousel.classList.add('is-dragging');
      } else {
        track.style.transition = 'none';
      }
    }

    function onMove(x) {
      if (!isDragging) return;
      dragDelta = x - startX;
      if (isDesktop()) {
        if (Math.abs(dragDelta) > 4) didDesktopDrag = true;
        carousel.scrollLeft = dragStartScroll - dragDelta;
        return;
      }
      var base = current * getSlideWidth();
      track.style.transform = 'translateX(' + (-base + dragDelta) + 'px)';
    }

    function onEnd() {
      if (!isDragging) return;
      isDragging = false;
      if (isDesktop()) {
        carousel.classList.remove('is-dragging');
        return;
      }
      track.style.transition = '';
      var threshold = getSlideWidth() * 0.2;
      if (dragDelta < -threshold) {
        goTo(current + 1);
      } else if (dragDelta > threshold) {
        goTo(current - 1);
      } else {
        goTo(current);
      }
      startAuto();
    }

    carousel.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    carousel.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    carousel.addEventListener('touchend', onEnd);

    carousel.addEventListener('mousedown', function (e) { onStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (isDragging) onMove(e.clientX); });
    window.addEventListener('mouseup', onEnd);
    carousel.addEventListener('click', function (e) {
      if (!didDesktopDrag) return;
      e.preventDefault();
      e.stopPropagation();
      didDesktopDrag = false;
    }, true);

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    goTo(0);
    startAuto();
  });
})();
